import Vue from 'vue'
import DateFormat from './dateFormat'

Vue.filter('dateFormat', DateFormat)
